import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, Users2, Building2, HeartHandshake, ArrowUpRight } from 'lucide-react';
import { ventureInfrastructure } from '../../mock';

const infraIcons = {
  innovpulse: Activity,
  // innovz: Users2,
  'studio-i': Building2,
  issi: HeartHandshake,
};

const infraLogos = {
  'studio-i': '/new_images/logos/studio-i.webp',
  innovpulse: '/new_images/logos/innovpulse.webp',
  // innovz: '/new_images/logos/innovz.webp',
  issi: '/new_images/logos/issi.webp'
};

const infraLogoBg = {
  'studio-i': 'bg-black border-white/20',
  innovpulse: 'bg-white/95 border-white/20',
  // innovz: 'bg-white/95 border-white/20',
  issi: 'bg-black border-white/20',
};

export default function Infrastructure() {
  return (
    <section id="infrastructure" className="relative bg-[#08080a] py-20 lg:py-28 border-t border-white/5 overflow-hidden">
      <div className="absolute top-1/2 -left-40 w-[600px] h-[600px] rounded-full bg-[#d42b92]/10 blur-[160px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <div className="reveal-up max-w-2xl">
            <div className="text-[#ff8ec5] text-xs font-semibold tracking-[0.25em] uppercase mb-4">
              Our Infrastructure
            </div>
            <h2 className="font-semibold tracking-tight text-white text-3xl sm:text-4xl md:text-5xl leading-[1.06]">
              The infrastructure behind the{' '}
              <span className="text-[#d42b92]">build</span>
            </h2>
          </div>
          <p className="reveal-up text-white/55 max-w-md text-base sm:text-lg leading-relaxed">
            InnovHer combines place, intelligence, talent and startup support to create an
            integrated venture-building environment.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {ventureInfrastructure.map((item, idx) => {
            const Icon = infraIcons[item.id] || Activity;
            const logo = infraLogos[item.id];
            const badgeBg = infraLogoBg[item.id] || 'bg-white/95 border-white/20';
            const card = (
              <>
                {logo ? (
                  <div className={`h-11 px-3 py-1.5 rounded-2xl ${badgeBg} border flex items-center justify-center mb-5 w-fit shadow-sm`}>
                    <img
                      src={logo}
                      alt={`${item.name} logo`}
                      className="h-6 w-auto max-w-[125px] object-contain"
                    />
                  </div>
                ) : (
                  <div className="w-11 h-11 rounded-2xl bg-[#d42b92]/15 border border-[#d42b92]/25 grid place-items-center mb-5">
                    <Icon className="w-5 h-5 text-[#ff8ec5]" />
                  </div>
                )}
                <div className="flex items-start justify-between gap-2">
                  <h3 className="text-xl font-semibold text-white">{item.name}</h3>
                  {item.href ? <ArrowUpRight className="w-4 h-4 text-[#ff8ec5] shrink-0 mt-1 opacity-70 group-hover:opacity-100" /> : null}
                </div>
                <div className="mt-1.5 text-xs uppercase tracking-wider text-[#ff8ec5] font-medium">
                  {item.type}
                </div>
                <p className="mt-4 text-sm text-white/55 leading-relaxed">{item.desc}</p>
              </>
            );

            const className =
              'reveal-up group rounded-3xl border border-white/10 bg-white/[0.02] p-7 hover:border-[#d42b92]/60 transition-colors block h-full';

            return item.href ? (
              <Link
                key={item.id}
                to={item.href}
                className={className}
                style={{ transitionDelay: `${idx * 60}ms` }}
              >
                {card}
              </Link>
            ) : (
              <div
                key={item.id}
                className={className}
                style={{ transitionDelay: `${idx * 60}ms` }}
              >
                {card}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
